/**
 * Remote extras loader — website build only (swapped in by scripts/build-widget.js).
 * Loads the extras bundle as a classic <script> (no CORS needed).
 */
export function loadRemoteScript(url: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load ReadingVox tools'));
    (document.head || document.documentElement).appendChild(script);
  });
}
